module.exports = __webpack_public_path__ + "images/linear-regression-24.webp";